import axios from "axios"
import authHeader from "./auth.header";
import { getLocalTimezoneName } from "../utils/utils";

class AuthService {
    login(user) {
        return axios({
            method: 'post',
            url: '/api/auth/login',
            headers: authHeader(),
            data: {
                user_name: user.username,
                password: user.password,
                authenticator_code: user.authCode,
                webcode: authHeader().webcode,
                timezone_name: getLocalTimezoneName()
            },
            withCredentials: true,
        }).then((response) => {
            return response.data
        })
    }

    loginAzure(idToken){
        return axios({
            method: 'post',
            url: '/api/auth/verifyAzureLogin',
            headers: authHeader(),
            data: {
                id_token: idToken,
                webcode: authHeader().webcode,
                timezone_name: getLocalTimezoneName()
            },
            withCredentials: true,
        }).then((response) => {
            return response.data
        })
    }

    getPortalFromWebcode(webcode){
        return axios({
            method: 'get',
            url: '/api/auth/get_portal_from_webcode',
            headers: authHeader(),
            params: {
                webcode: webcode
            }
        }).then((response) => {
            return response.data
        })
    }

    async validatePin(params) {
        return axios({
            method: 'post',
            url: '/api/auth/validateTwoFaPin',
            headers: authHeader(),
            data: {
                authenticator_code: params.authenticatorCode,
                token: params.token
            },
        })
    }

    async generateTwoFaToken() {
        return axios({
            method: 'get',
            url: '/api/auth/generateTwoFaToken',
            headers: authHeader()
        }).then((response) => {
            return response.data
        })
    }

    async generateTwoFaTokenInvite(email) {
        return axios({
            method: 'get',
            url: '/api/auth/generateTwoFaTokenInvite',
            headers: authHeader(),
            params: {
                email
            }
        }).then((response) => {
            return response.data
        })
    }

    disableTwoFa(password) {
        return axios({
            method: 'delete',
            url: '/api/auth/disableTwoFa',
            headers: authHeader(),
            params: {
                password: password
            }
        })
    }

    refreshJwtToken() {
        return axios({
            method: 'get',
            url: '/api/auth/refreshJwtToken',
            headers: authHeader(),
            withCredentials: true,
            params: {
                timezoneName: getLocalTimezoneName()
            }
        }).then((response) => {
            return response.data
        })
    }
    
    searchApiLogins(query, startIndex, pageSize, sortOrder, cancelToken) {
        return axios({
            method: 'post',
            url: '/api/auth/search_api_logins',
            headers: authHeader(),
            data: {
                name: query.name,
                role_id: query.role_id,
                start_index: startIndex,
                page_size: pageSize,
                sort_order: sortOrder,
            },
            cancelToken: cancelToken
        })
    }

    registerApiLogin(name, roleId, claims) {
        return axios({
            method: 'post',
            url: '/api/auth/register_api_login',
            headers: authHeader(),
            data: {
                name: name,
                role_id: roleId,
                claims
            }
        })
    }

    listApiLoginTypes() {
        return axios({
            method: 'get',
            url: '/api/auth/list_api_login_types',
            headers: authHeader()
        })
    }

    updateApiLogin(id, name, roleId) {
        return axios({
            method: 'post',
            url: '/api/auth/update_api_login',
            headers: authHeader(),
            data: {
                id,
                name,
                role_id: roleId
            }
        })
    }

    deleteApiLogin(id) {
        return axios({
            method: 'post',
            url: '/api/auth/delete_api_login',
            headers: authHeader(),
            params: {
                id
            }
        })
    }

    getPortalConfiguration(){
        return axios({
            method: 'get',
            url: '/api/auth/get_portal_configuration',
            headers: authHeader()
        })  
    }

    updatePortalConfiguration(portalConfigurations){
        return axios({
            method: 'post',
            url: '/api/auth/update_portal_configuration',
            headers: authHeader(),
            data: {
                portal_id: portalConfigurations.portalId,
                allow_azure_sso: portalConfigurations.allowAzureSSO, 
                province_localization: portalConfigurations.provinceLocalization,
                postal_code_localization: portalConfigurations.postalCodeLocalization,
                transaction_days_back: portalConfigurations.transactionDaysBack,
                services_email: portalConfigurations.servicesEmail,
                receipt_generator: portalConfigurations.receiptGenerator,
                receipt_email: portalConfigurations.receiptEmail,
                coupon_length: portalConfigurations.couponLength,
                show_response_message: portalConfigurations.showResponseMessage, 
                show_gst_reg: portalConfigurations.showGSTReg
            }
        });
    }

    forgotPassword(username) {
        return axios({
            method: 'post',
            url: '/api/auth/forgot_password',
            headers: authHeader(),
            params: {
                webcode: authHeader().webcode,
                username: username
            }
        });
    }

    newPassword(password, forgotPasswordToken, authCode) {
        return axios({
            method: 'post',
            url: '/api/auth/new_password',
            headers: authHeader(),
            data: {
                new_password: password,
                forgot_password_token_id: forgotPasswordToken,
                authenticator_code: authCode,
                webcode: authHeader().webcode,
            }
        })
    }
}

export default new AuthService()